/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.pageViewModule')
.directive('bulbRecommendLogin', bulbRecommendLogin);

function bulbRecommendLogin() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/pageview/pageviewfooter-login.html',
    controller: 'PageViewFooterLoginController as pageViewFooterLoginCtrl'
  };
}
